// extracted by mini-css-extract-plugin
export default {"modalContent":"ConfirmModal_modalContent__FqZZh","title":"ConfirmModal_title__aYDmf","message":"ConfirmModal_message__11uaL","actions":"ConfirmModal_actions__Ec0h4"};